<template>
  <div class="treeMain" id="treeMain">
    <border class="site-tree" :width="width" percentHeight="100%" top="0" background="transparent">
      <div class="project-box">
        <div class="content">
          <div class="box">
            <div>
              <div class="header-box" v-if="showArea">
                <a-radio-group v-model="type" @change="onChange" button-style="solid">
                  <a-radio-button value="1">区域</a-radio-button>
                  <a-radio-button value="2">流域</a-radio-button>
                </a-radio-group>
              </div>
              <div class="header-box" v-else-if="all">
                <a-radio-group v-model="type" @change="onChange" button-style="solid">
                  <a-radio-button value="1">区域</a-radio-button>
                  <a-radio-button value="3">管网</a-radio-button>
                </a-radio-group>
              </div>
              <div style="padding: 10px 0px" v-if="type == 1 && stList.length > 2">
                <a-select
                  style="width: 265px"
                  v-model="st"
                  placeholder="请选择监测站点类型"
                  @change="typeChange"
                  showSearch
                  :filterOption="filterOption"
                >
                  <a-select-option v-for="(item, i) in stList" :key="i" :value="item.value">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div style="padding: 10px 5px 10px 0">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini"></el-input>
              <el-tree
                accordion
                ref="tree"
                :data="treeData"
                :default-expanded-keys="expandedKeys"
                node-key="key"
                :current-node-key="currentKey"
                :render-content="renderContent"
                :filter-node-method="filterNode"
                :props="defaultProps"
                :highlight-current="true"
                @node-click="onSelect"
              ></el-tree>
            </div>
          </div>
        </div>
      </div>
    </border>
  </div>
</template>

<script>
import { querySiteTree, getTenantStByToken } from '@/api/api'
import border from '@/components/border/borderType'
export default {
  name: 'pipeNetwork',
  props: {
    initialSiteId: { default: null },
    type: {
      default: '1',
    },
    all: {
      default: false,
    },
    showArea: {
      default: false,
    },
  },
  data() {
    return {
      st: '',
      width: '300',
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      treeData: [],
      expandedKeys: [],
      currentKey: '',
      testLength: 11,
      minute: 5, //刷新树时间
      stList: [],
      isFor: true
    }
  },
  components: {
    border,
  },
  watch: {
    initialSiteId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectTargetSite(val)
        }
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  mounted() {
    this.getTenantStList()
    this.loadTree(this.type, this.st)
    this.treeRefreshTimer = setInterval(() => {
      this.isFor = true
      this.loadTree(this.type, this.st)
    }, 1000 * 60 * this.minute)
  },
  beforeDestroy() { clearInterval(this.treeRefreshTimer) },
  methods: {
    filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text)
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getTenantStList() {
      this.stList = []
      getTenantStByToken().then((res) => {
        if (res.success) {
          this.stList = res.result
          this.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型',
          })
          if (!this.initialSiteId && res.result.length <= 2) {
            this.typeChange(res.result[1].value)
          }
        } else {
          this.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型',
          })
        }
      })
    },
    // 类型字典变化
    typeChange(val) {
      this.st = val
      this.loadTree(this.type, val)
    },
    // 过滤节点
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    onChange(e) {
      console.log(`checked = ${e.target.value}`)
      this.loadTree(e.target.value, this.st)
    },
    // 自定义图标
    renderContent(h, { node, data, store }) {
      if (this.type == 2) {
        return (
          <span
            class="custom-tree-node"
            style="width: 90%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;"
          >
            <div style="display:flex;align-items:center;">{node.label}</div>
          </span>
        )
      }
      var icon
      if (data.data && data.data.st) {
        switch (data.data.st) {
          case '31':
            icon = 'icon-feiqi'
            break
          case '32':
            icon = 'icon-yiliaofeishui'
            break
          case '35':
            icon = 'icon-turang'
            break
          case '21':
            icon = 'icon-shuizhijiancezhan'
            break
          case '22':
            icon = 'icon-kongqijiance'
            break
          case '61':
            icon = 'icon-shuikushuiwenzhan'
            break
          case '52':
            icon = 'icon-yiliaofeishui'
            break
        }
      }
      var rex = /^[a-zA-Z]/
      // if (data.total == 0 && rex.test(data.key[0])) {
      // } else {
      return (
        <span class="custom-tree-node">
          <span
            v-show={data.isLeaf && !rex.test(data.key[0])}
            title={
              node.label +
              '\n' +
              (data.online ? '在线' : '离线') +
              (data.data.currentStandard ? '，' + data.data.currentStandard.title : '') +
              (data.data.upStandard === 'true' ? '，达标' : data.data.upStandard === null ? '' : '，不达标') +
              (data.data.lastTime ? '\n' + data.data.lastTime : '')
            }
            style="display:flex;align-items:center;"
          >
            <div v-show={data.online} style="font-size:13px;margin-right:3px;" class={'iconfont ' + icon}></div>
            <div
              v-show={!data.online}
              style="font-size:13px;margin-right:3px;color:gray;"
              class={'iconfont ' + icon}
            ></div>
            {node.label.length > this.testLength - 2 ? node.label.slice(0, this.testLength - 2) + '...' : node.label}
          </span>
          <span v-show={!data.isLeaf}>
            {node.label}({data.onlineNum}/{data.total})
          </span>
          <div
            v-show={data.data.currentStandard && data.isLeaf}
            style={{
              'font-size': '12px',
              height: '20px',
              'line-height': '20px',
              padding: '0px 5px',
              'border-radius': '5px',
              position: 'absolute',
              right: '0',
              top: '3px',
              color: '#000',
              'background-color': data.data.currentStandard ? data.data.currentStandard.color : 'gray',
            }}
          >
            {data.data.currentStandard ? data.data.currentStandard.title : ''}
          </div>
          <div
            v-show={!data.data.currentStandard && data.isLeaf && data.data.upStandard === 'true'}
            style="font-size:12px;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:green;color:#fff;"
          >
            达标
          </div>
          <div
            v-show={!data.data.currentStandard && data.isLeaf && data.data.upStandard === 'false'}
            style="font-size:12px;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:red;color:#fff;"
          >
            不达标
          </div>
        </span>
      )
      // }
    },
    selectTargetSite(targetId) {
      if (!targetId || !this.treeData || !this.treeData.length) return false
      const targetStr = String(targetId)
      const path = []
      let foundNode = null

      const search = (nodes) => {
        if (!nodes || !nodes.length) return false
        for (const item of nodes) {
          path.push(item.key)
          const isMatch = (item.isLeaf || (!item.children || !item.children.length)) &&
            (String(item.key) === targetStr || (item.data && String(item.data.id) === targetStr))
          if (isMatch) {
            foundNode = item
            return true
          }
          if (item.children && item.children.length > 0) {
            if (search(item.children)) return true
          }
          path.pop()
        }
        return false
      }

      if (search(this.treeData) && foundNode) {
        this.currentKey = foundNode.key
        sessionStorage.setItem('pipeId', this.currentKey)
        sessionStorage.setItem('siteId', this.currentKey)
        this.expandedKeys = Array.from(new Set([...this.expandedKeys, ...path]))
        this.$nextTick(() => {
          if (this.$refs.tree) {
            this.$refs.tree.setCurrentKey(this.currentKey)
            const treeNode = this.$refs.tree.getNode(this.currentKey)
            if (treeNode) {
              let p = treeNode.parent
              while (p) {
                p.expanded = true
                p = p.parent
              }
            }
          }
          this.$emit('change', {
            type: this.type == 3 ? 2 : 1,
            data: foundNode.data,
            scope: this.getTreeCurrentId(this.currentKey),
          })
        })
        return true
      }
      return false
    },
    getLast(list) {
      if (!list || list.length === 0) return
      const targetId = this.initialSiteId || sessionStorage.getItem('pipeId')
      if (targetId && this.selectTargetSite(targetId)) {
        return
      }

      // 未匹配到特定站点时，默认展开第一分支并选中第一个叶子节点
      const defaultPath = []
      let defaultLeaf = null
      const findFirst = (nodes) => {
        if (!nodes || !nodes.length) return false
        for (const item of nodes) {
          defaultPath.push(item.key)
          if (item.isLeaf || (!item.children || !item.children.length)) {
            defaultLeaf = item
            return true
          }
          if (findFirst(item.children)) return true
          defaultPath.pop()
        }
        return false
      }
      findFirst(list)
      if (defaultLeaf) {
        this.currentKey = defaultLeaf.key
        sessionStorage.setItem('pipeId', this.currentKey)
        this.expandedKeys = Array.from(new Set([...this.expandedKeys, ...defaultPath]))
        this.$nextTick(() => {
          if (this.$refs.tree) {
            this.$refs.tree.setCurrentKey(this.currentKey)
            const treeNode = this.$refs.tree.getNode(this.currentKey)
            if (treeNode) {
              let p = treeNode.parent
              while (p) {
                p.expanded = true
                p = p.parent
              }
            }
          }
          this.$emit('change', {
            type: this.type == 3 ? 2 : 1,
            data: defaultLeaf.data,
            scope: this.getTreeCurrentId(this.currentKey),
          })
        })
      }
    },
    getTreeCurrentId(key) {
      if (!key) {
        return null
      } else {
        var rex = /^[a-zA-Z]/
        console.log('rex', rex.test(key))
        if (rex.test(key)) {
          if (key.split('_')[0] == 'A') {
            //  返回数组的第一个值为2   区域id
            return 2
          } else if (key.split('_')[0] == 'R') {
            //  返回数组的第一个值为3   流域id
            return 3
          } else if (key.split('_')[0] == 'C') {
            //  返回数组的第一个值为4   公司id
            return 4
          } else if (key.split('_')[0] == 'G') {
            //  返回数组的第一个值为4   公司id
            return 5
          }
        } else {
          // 返回数组的第一个值为1    站点id
          return 1
        }
      }
    },
    // 加载树数据
    loadTree(addrType, st) {
      // addrType = addrType?addrType:3
      var that = this
      querySiteTree({
        addrType,
        st,
      }).then((res) => {
        if (res.success) {
          that.treeData = res.result
          that.getLast(res.result)
        }
      })
    },
    onSelect(data, node) {
      if (data.isLeaf) {
        var rex = /^[a-zA-Z]/
        if (!rex.test(data.key[0])) {
          this.$nextTick(() => {
            this.currentKey = data.key
            sessionStorage.setItem('pipeId',this.currentKey)
            this.$emit('change', {
              type: this.type == 3 ? 2 : 1,
              data: data.data,
              scope: this.getTreeCurrentId(this.currentKey),
            })
          })
        }
      } else {
        var areaId = data.key
        var rex = /^[a-zA-Z]/
        if (rex.test(areaId[0])) {
          this.$emit('change', {
            type: 4,
            data: data.data,
            scope: this.getTreeCurrentId(data.key),
          })
          // if(this.type==1){
          //   this.$message_custom('请选择站点','warn')
          // }else{
          //   this.$message_custom('请选择管网','warn')
          // }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.treeMain {
  height: calc(88vh - 5px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .project-box {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 0px 10px 10px;
    .content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .box {
        width: 270px;
        height: 100%;
        overflow-y: auto;
        .header-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        ::v-deep .ant-radio-button-wrapper {
          background: transparent;
          color: #1890ff;
          border-color: #1890ff;
        }
        ::v-deep .ant-radio-button-wrapper-checked {
          color: #fff !important;
          background: #1890ff;
          border-color: #1890ff !important;
        }
        ::v-deep .el-input__inner {
          background-color: transparent;
          border-color: #1890ff;
        }
        ::v-deep .ant-btn {
          background-color: transparent !important;
          color: #1890ff;
          border-color: #1890ff;
        }
        ::v-deep .ant-btn-primary {
          background-color: #1890ff !important;
          color: #fff;
          border-color: #1890ff;
        }
        ::v-deep .ant-select-selection {
          background-color: transparent;
          color: #dcdfe6;
          font-size: 12px;
          border-color: #1890ff;
        }
        ::v-deep .ant-select-selection--single {
          height: 29px;
        }
        ::v-deep .ant-select-selection__rendered {
          line-height: 29px;
        }
        ::v-deep .ant-select-arrow {
          color: #1890ff;
        }
        .el-tree {
          background-color: transparent;
          color: #1890ff;
          ::v-deep .el-tree-node.is-current > .el-tree-node__content {
            background-color: #1890ff !important;
            color: #fff !important;
          }
          ::v-deep .el-tree-node {
            &:focus {
              .el-tree-node__content {
                background-color: transparent;
              }
            }
          }
          ::v-deep .el-tree-node__content {
            display: flex;
            width: 100%;
            position: relative;
            .custom-tree-node {
              display: inline-block;
              height: 100%;
              line-height: 27px;
            }
            &:hover {
              background-color: #1890ff !important;
              color: #fff !important;
            }
          }
        }
        .box-top {
          width: 100%;
          height: 40px;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
        .box-bottom {
          box-sizing: border-box;
          height: calc(100% - 40px);
          overflow-y: scroll;
          padding: 10px 0;
          .list-item {
            width: calc(100% - 5px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            cursor: pointer;
            &:hover {
              background-color: #1890ff;
              color: #fff;
            }
            &.active {
              background-color: #1890ff;
              color: #fff;
            }
          }
        }
      }
      .close {
        width: 10px;
        font-size: 12px;
        height: 172px;
        line-height: 172px;
        background-color: #2c58a6;
        color: #fff;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        /*z-index: 1000;*/
        cursor: pointer;
      }
    }
  }
  .show {
    width: 10px;
    font-size: 12px;
    height: 172px;
    line-height: 172px;
    background-color: #2c58a6;
    color: #fff;
    /*z-index: 1000;*/
    cursor: pointer;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>